import { useTranslation } from "react-i18next";
import AuthoringPage from "../AuthoringPage";
import StepForm from "./StepForm";

/** `/workflows/new/step`: the step form for a new step (AU-4). */
export default function NewStepPage() {
  const { t } = useTranslation();
  return (
    <AuthoringPage title={t("authoring.step.newTitle")} intro={t("authoring.step.intro")}>
      {(projectId, options) => <StepForm projectId={projectId} options={options} base={null} />}
    </AuthoringPage>
  );
}
